<template>
  <div>
    <h2>{{$t('TEXT_TRANSFER')}} {{wallet.name}} ({{(wallet.displaySymbol)}})</h2>
    <form class="popup-inner" @submit.prevent="doTransferInternal" :class="{ 'loading': isProcessing }">
      <div class="item">
        <label v-html="$t('TEXT_TO_ADDRESS')"></label>
        <input
          type="text"
          autocomplete="off"
          required
          v-model="form.toAddress"
        >
      </div>
      <div class="item">
        <label v-html="$t('TEXT_AMOUNT')"></label>
        <input
          type="text"
          autocomplete="off"
          required
          v-model="form.amount"
          :placeholder="`0.00 ${wallet.displaySymbol}`"
        >
        <span class="field-description error-text" v-if="form.amount && !isValidAmount">
          {{ $t('TEXT_MIN_TRANSFER') }} {{minCurrencyTransferInternal}}&nbsp;{{ wallet.displaySymbol }},
          {{ $t('TEXT_MAX_TRANSFER') }} {{maxCurrencyWithdraw}}&nbsp;{{ wallet.displaySymbol }}
        </span>
        <span class="field-description error-text" v-if="form.amount && isValidAmount && isInValidAmountPrecision">
          {{ $t('MSG_MAXIMUM_AMOUNT_PRECISION_IS', { amountPrecision: this.wallet.numberDecimal}) }}
        </span>
        <span class="field-description error-text" v-else-if="isNaNAmount">
          {{ $t('MSG_AMOUNT_MUST_BE_A_NUMBER') }}
        </span>
        <p class="item-description">
          (
          <a :class="{'disabled': wallet.balance === 0}" @click="swapMax">
            <span >{{ $t('BTN_MAX') }}</span>
          </a>
          -
          <a :class="{'disabled': wallet.balance === 0}" @click="swapMin">
            <span>{{ $t('BTN_MIN') }}</span>
          </a>
          )
        </p>
      </div>
      <div class="item item-balance">{{ $t('TEXT_BALANCE') }}: <span>{{ wallet.beautyBalance }} {{wallet.displaySymbol}}</span></div>
      <div class="item item-fee">
        <div class="flex-box">
          <div style="flex-basis: 140px">{{ $t('TEXT_TRANSFER_FEE') }}:</div>
          <div class="flex-grow dark-color">
            <span>{{ feeTransferInternal }}</span>&nbsp;
            <span>{{ wallet.transferInternalFeeSymbol || wallet.displaySymbol }}</span>
          </div>
        </div>
        <div class="flex-box">
          <div style="flex-basis: 140px">{{$t('TEXT_YOU_WILL_TRANSFER')}}: </div>
          <div class="flex-grow buy-color">
            <span>{{ estimatedWithdrawalAmount }}</span>&nbsp;
            <span>{{ wallet.displaySymbol }}</span>
          </div>
        </div>
        <div class="flex-box">
          <div style="flex-basis: 140px">&nbsp;</div>
          <div class="flex-grow buy-color">
            <span class="field-description error-text" v-if="!isValidFeeAmount">
              {{ $t('MSG_FEE_IS_NOT_ENOUGH') }}
            </span>
          </div>
        </div>
      </div>
      <div class="item item-submit">
        <a class="btn btn-submit" :class="{ 'disabled': !isValidated }" @click="doTransferInternal">{{ $t('BTN_TRANSFER') }}</a>
      </div>
    </form>
  </div>
</template>

<script>
import UtilService from '@/utils/UtilService'
export default {
  props: {
    wallet: {},
    feeWallet: {}
  },
  data () {
    return {
      form: {
        amount: null
      },
      isProcessing: false
    }
  },
  computed: {
    pagination () {
      return this.$store.getters.pagination
    },
    user () {
      return this.$store.getters.user
    },
    wallets () {
      return this.$store.getters.ieoBalances
    },
    isExternalFee () {
      return this.wallet.transferInternalFeeSymbol && this.wallet.transferInternalFeeSymbol !== this.wallet.symbol
    },
    isValidFeeAmount () {
      if (this.isExternalFee) {
        const result = UtilService.isLessOrEqual(this.feeTransferInternal, this.feeWallet.balance)
        return result
      }
      return true
    },
    isValidAmount () {
      let result = null
      if (this.form.amount && UtilService.isLargerOrEqual(this.form.amount, this.minCurrencyTransferInternal) &&
        UtilService.isLessOrEqual(this.form.amount, this.maxCurrencyWithdraw)) {
        result = true
      } else result = false
      return result
    },
    feeTransferInternal () {
      return UtilService.calculateFeeTransferInternal(this.form.amount, this.wallet)
    },
    maxCurrencyWithdraw () {
      let result = 0
      this.wallet.balanceMain > this.wallet.transferInternalMaxAmount ? result = this.wallet.transferInternalMaxAmount : result = this.wallet.balanceMain
      return UtilService.maxAmountWithoutInternalFee(result, this.feeTransferInternal, this.wallet)
    },
    estimatedWithdrawalAmount () {
      if (!this.form.amount) return 0
      return UtilService.estimateTransferInternalAmount(this.form.amount, this.feeTransferInternal, this.wallet)
    },
    configs () {
      return this.$store.getters.configs
    },
    minTransferInternal () {
      return this.wallet.transferInternalMinAmount || 0
    },
    minCurrencyTransferInternal () {
      return this.minTransferInternal || 0
    },
    isValidated () {
      return this.form.amount && this.isValidAmount && !this.isInValidAmountPrecision && !this.isNaNAmount && this.isValidFeeAmount &&
        this.form.toAddress && this.form.toAddress.toLowerCase() !== this.user.address
    },
    isInValidAmountPrecision () {
      return this.form.amount && !UtilService.checkValidAmountDecimals(this.form.amount, this.wallet.numberDecimal)
    },
    isNaNAmount () {
      return !this.isInValidAmount && this.form.amount && isNaN(this.form.amount)
    }
  },
  created () {
    console.log('Created')
  },
  methods: {
    swapMax () {
      if (this.wallet.balanceMain > 0) {
        this.form.amount = this.maxCurrencyWithdraw
      }
    },
    swapMin () {
      if (this.wallet.balanceMain > 0) {
        this.form.amount = this.minCurrencyTransferInternal
      }
    },
    doTransferInternal () {
      if (!this.isValidated) return
      const data = {}
      data.currency = this.wallet.symbol
      data.amount = this.form.amount
      data.toAddress = this.form.toAddress
      this.isProcessing = true
      this.$store.dispatch('transferInternal', data).then(status => {
        setTimeout(() => {
          this.isProcessing = false
          if (status) {
            this.$store.dispatch('toggleAmountForm')
            this.$store.dispatch('getTransHistory', this.pagination.currentPage || 1)
          }
        }, 500)
      })
    }
  }
}
</script>
